export default {
  /**
   * Tells if given channel appears unconnected, because all boards
   * are invisible
   * @param {String} channel
   * @param {Object} invisibleChannels
   * @returns {Boolean}
   */
  isFalseUnconnected (channel = null, invisibleChannels = {}) {
    return !!invisibleChannels[channel]
  }
}


// WEBPACK FOOTER //
// ./src/assets/modules/channels/connectionHelper.js